// extracted by mini-css-extract-plugin
export default {"Error_Container":"Error_Error_Container__v7NnD","custom_btn":"Error_custom_btn__Jh6Ow"};